import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Users, Luggage, Star, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import OptimizedImage from "@/components/OptimizedImage";
import audiNightImage from "@/assets/audi-night-city.jpeg";
import audiNightImageSrcset from "@/assets/audi-night-city.jpeg?responsive";

const FleetShowcase = () => {
  const vehicle = {
    name: "2025 Audi Q7 Black Optic Executive",
    type: "Premium Luxury SUV",
    priceRange: "$100-135/hour",
    passengers: "Up to 6",
    luggage: "2-4 bags",
    image: audiNightImage,
    imageSrcset: audiNightImageSrcset,
    features: ["Executive Package", "Valcona Leather", "Bang & Olufsen Audio", "Panoramic Sunroof"],
    rating: "5.0"
  };

  return (
    <section className="py-20 bg-secondary">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-foreground mb-4">
            Our Fleet
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Experience luxury and comfort in our meticulously maintained Luxury SUV
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Card className="card-luxury overflow-hidden">
            <div className="grid grid-cols-1 md:grid-cols-2">
              <div className="relative h-64 md:h-auto">
                <OptimizedImage
                  src={vehicle.image}
                  srcSet={vehicle.imageSrcset}
                  sizes="(max-width: 768px) 100vw, 50vw"
                  alt="Luxury Executive Car Service San Antonio Audi Q7 - Rick's Black Car Service premium SUV"
                  className="w-full h-full object-cover"
                  width={800}
                  height={600}
                />
              </div>
              <CardContent className="p-8 space-y-6">
                <div>
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-semibold text-primary uppercase tracking-wider">
                      {vehicle.type}
                    </span>
                    <div className="flex items-center gap-1">
                      <Star className="w-5 h-5 fill-primary text-primary" />
                      <span className="font-semibold text-foreground">{vehicle.rating}</span>
                    </div>
                  </div>
                  <h3 className="text-2xl font-serif font-bold text-foreground mb-2">
                    {vehicle.name}
                  </h3>
                  <p className="text-lg text-primary font-semibold">{vehicle.priceRange}</p>
                </div>

                <div className="space-y-3">
                  <div className="flex items-center gap-3 text-muted-foreground">
                    <Users className="w-5 h-5 text-primary" />
                    <span>{vehicle.passengers} passengers</span>
                  </div>
                  <div className="flex items-center gap-3 text-muted-foreground">
                    <Luggage className="w-5 h-5 text-primary" />
                    <span>{vehicle.luggage}</span>
                  </div>
                </div>

                <div className="space-y-2">
                  <p className="text-sm font-semibold text-foreground uppercase tracking-wider">
                    Features
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {vehicle.features.map((feature, i) => (
                      <span
                        key={i}
                        className="px-3 py-1 bg-primary/10 text-primary text-sm rounded-full"
                      >
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>

                <Button className="btn-luxury w-full" asChild>
                  <Link to="/fleet">
                    View Full Details
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Link>
                </Button>
              </CardContent>
            </div>
          </Card>

          <div className="mt-8 text-center">
            <p className="text-muted-foreground mb-4">
              For groups larger than 6 passengers, we can schedule multiple SUV trips
            </p>
            <Button variant="outline" asChild>
              <a href="tel:+12102967409">Call (210) 296-7409 for Custom Solutions</a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
export default FleetShowcase;
